import style from "./PreviousAddressDetails.module.css";
import { useSelector } from "react-redux";
import clsx from "clsx";
import React from "react";
import { selectPreviousAddress } from "@/slices/PreviousAddressSlice";
import { useNavigate } from "react-router-dom";

export default function PreviousAddressDetails(props: any) {
  const navigate = useNavigate();

  const previousAddresses = useSelector(selectPreviousAddress).addresses;

  const previousAddressList = () => {
    return previousAddresses.map((position: any) => {
      return (
        <React.Fragment key={position.id}>
          <div className="flex md:flex-row flex-col mb-4">
            <div className={style.twoColFirst}>
              <div className={clsx(position.city != "" ? "" : "hidden")}>
                <p id="formatted-address"></p>
                {position.address != "" && <><span >{position.streetNumber} {position.streetName} {position.streetType}</span><br /></>}
                {position.city != "" && <><span >{position.city}</span> &nbsp;</>}
                {position.province != "" && <><span >{position.province}</span>&nbsp;</>}
                {position.postalCode != "" && <><span >{position.postalCode}</span><br /></>}
                {position.country != "" && <span >{position.country}</span>}
              </div>
            </div>
            <div>
              <div className={clsx(position.city != "" ? "" : "hidden")}>
                <p className="mt-5 text-sm">How long have you lived at this address?</p>
                <h5 className="mt-3">
                  {position.yearsLivedOn > 0 && position.yearsLivedOn + " Year" + (position.yearsLivedOn != 1 ? "s" : "")}
                  {position.yearsLivedOn > 0 && position.monthsLivedOn > 0 && " & "}
                  {position.monthsLivedOn > 0 && position.monthsLivedOn + " Month" + (position.monthsLivedOn != 1 ? "s" : "")}
                </h5>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <hr className="mt-5" />
      <div className="flex flex-row justify-between mt-5">
        <h2>Address History</h2>
        <h3
          className="brand-blue-text text-xs grid grid-flow-col cursor-pointer"
          onClick={() => {
            navigate("/single/previousaddress", { state: { editMode: true } });
          }}
        >
          <img
            src="assets/edit-icon.svg"
            className={style.editIcon}
            alt="edit"
          />
          <span>Edit</span>
        </h3>

      </div>
      <div className={clsx(style.caContainer, "mt-5")}>
        {previousAddressList()}
      </div>
    </>
  );
}
